import { Box, Checkbox, Container, Divider, Modal } from "@mantine/core";
import { useState } from "react";
import { type IAdminShort } from "src/components/pages/Management/ManagementTable/AdminsRow";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import { useGetApi } from "src/hooks";

interface Props {
  opened: boolean;
  close: () => void;
}

const mapUsers = (data: any): IAdminShort[] => {
  return data.data;
};

const AdminsListModal = ({ opened, close }: Props) => {
  const [deleted, setDeleted] = useState(false);
  const { data, isLoading } = useGetApi({
    request: "get-admins",
    body: {
      _sect: "_admins",
      params: {
        clientid: "6dfb8433-6130-ef36-356a-6f205a2528fc",
      },
    },
    mapper: mapUsers,
  });

  const deletedUsersCount = data?.filter(user => user.deleted).length;

  const handleViewToggle = () => {
    setDeleted(!deleted);
  };

  return (
    <Modal size={"900px"} opened={opened} onClose={close} title="Admin list">
      <Divider
        my="xs"
        variant="dashed"
        labelPosition="right"
        label={
          <>
            <Checkbox checked={deleted} onClick={handleViewToggle} />
            <Box ml={5}>Deleted admin users ({deletedUsersCount})</Box>
          </>
        }
      />
      <Container p={"0px"}>
        <ManagementTable
          section="_admins"
          data={
            data?.filter(user => (deleted ? user.deleted : !user.deleted)) ?? []
          }
          loading={isLoading}
        />
      </Container>
    </Modal>
  );
};

export default AdminsListModal;
